<template>
  <a @click.prevent="settingAudio()" :disabled="disabled">
    <img :src="audio? require('../assets/audioON.png') : require('../assets/audioOFF.png')" width="30" height="30"/>
  </a>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "AudioSetting",
  props: {
    'disabled': {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      audio: "audioSetting"
    })
  },
  methods: {
    settingAudio() {
      this.$store.commit("changeAudioSetting");
    },
  },
};
</script>
<style>
@import "../assets/css/app.css";
</style>
